import axios from 'axios';
// import { camelizeKeys } from 'humps';
const API = axios.create({ baseURL: process.env.REACT_APP_API_URL });

// API.interceptors.response.use((response: AxiosResponse) => {
//   if (response.data && response.headers['content-type'] === 'application/json') {
//     response.data = camelizeKeys(response.data);
//   }
//   return response;
// });

export default API;
